export const FREE_TIER_ID = '00000000-0000-0000-0000-000000000000';
export const STARTER_TIER_ID = 'a1b2c3d4-5e6f-7a8b-9c0d-1e2f3a4b5c6d';
export const TEAM_TIER_ID = 'b7e9d2f4-6a1c-4e8b-9d3f-2c5a8b4e7f1a';
export const INDUSTRIAL_TIER_ID = 'c3f8e1a6-7b2d-4c9e-8f1a-3d5b6c7e8f9a';
export const ENTERPRISE_TIER_ID = 'd9a4b5c6-8d1e-4f2a-9b3c-4e5f6a7b8c9d';

export const SUBSCRIPTION_TIERS = [
  { id: FREE_TIER_ID, name: 'Free' },
  { id: STARTER_TIER_ID, name: 'Starter' },
  { id: TEAM_TIER_ID, name: 'Team' },
  { id: INDUSTRIAL_TIER_ID, name: 'Industrial' },
  { id: ENTERPRISE_TIER_ID, name: 'Enterprise' },
];
